import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

interface Props {
    height?: number;
    width?: string;
    backgroundColor?: string;
}

export const SpaceDiv = styled.div<Props>`
    height: ${(props) => (props.height ? props.height : '1')}px;
    width: ${(props) => (props.width ? css`${props.width}` : '100%')};
    background-color: ${(props) => (props.backgroundColor ? palette(props.backgroundColor) : palette('transparent'))};
`;